import { requestJson } from './http-json';

export type FactoryIdentityState = 'unverified' | 'pending' | 'verified' | 'failed' | 'expired';
export interface FactoryIdentityStatus {
  required: boolean;
  available: boolean;
  status: FactoryIdentityState;
  masked_name: string | null;
  masked_cert_no: string | null;
  verified_at: string | null;
  consent_version: string;
}
const BASE = '/api/v1/me/factory/identity';
const states: string[] = ['unverified', 'pending', 'verified', 'failed', 'expired'];

function checkedStatus(value: FactoryIdentityStatus): FactoryIdentityStatus {
  if (!value || typeof value.required !== 'boolean' || typeof value.available !== 'boolean'
      || !states.includes(value.status)) throw new Error('无法读取实名认证状态，请重试。');
  return value;
}
export async function getFactoryIdentityStatus() {
  return checkedStatus(await requestJson<FactoryIdentityStatus>(BASE, {}, '读取实名认证状态'));
}
export async function refreshFactoryIdentityStatus() {
  return checkedStatus(await requestJson<FactoryIdentityStatus>(`${BASE}/refresh`, { method: 'POST' }, '查询实名认证结果'));
}
export async function startFactoryIdentity(expertId: string, name: string, certNo: string) {
  const value = await requestJson<{ verification: FactoryIdentityStatus; certify_url: string | null }>(`${BASE}/start`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ expert_id: expertId, cert_name: name.trim(), cert_no: certNo.trim().toUpperCase(), consent: true }),
  }, '发起实名认证');
  checkedStatus(value.verification);
  if (value.certify_url !== null) {
    const url = new URL(value.certify_url);
    if (url.protocol !== 'https:' || url.username || url.password
      || !['openapi.alipay.com', 'openapi-sandbox.dl.alipaydev.com'].includes(url.hostname)
      || url.pathname !== '/gateway.do'
      || url.searchParams.get('method') !== 'alipay.user.certify.open.certify') {
      throw new Error('认证地址无效，请刷新后重试。');
    }
  } else if (value.verification.status !== 'verified') {
    throw new Error('暂时无法发起认证，请重试。');
  }
  return value;
}

export function navigateToAlipayIdentity(url: string) {
  window.location.assign(url);
}
